/**
 * Texto largo. Crece con el contenido hasta un tope: un textarea de tres lineas
 * fijas obliga a scrollear dentro de un scroll, que es la peor forma de leer una
 * observacion de mantenimiento.
 */

import { useLayoutEffect, useRef } from 'react';

import { areaClass } from '@/components/fields/controls';
import { ReadonlyOutput } from '@/components/fields/FieldDisplay';
import type { FieldInputProps } from '@/components/fields/types';

const ALTURA_MAXIMA = 320;

export function TextField({
  id,
  meta,
  value,
  onChange,
  readonly,
  required,
  invalid,
  describedBy,
}: FieldInputProps) {
  const ref = useRef<HTMLTextAreaElement>(null);
  const texto = typeof value === 'string' ? value : value === null || value === undefined ? '' : String(value);

  useLayoutEffect(() => {
    const nodo = ref.current;
    if (nodo === null) return;
    nodo.style.height = 'auto';
    nodo.style.height = `${Math.min(nodo.scrollHeight, ALTURA_MAXIMA)}px`;
  }, [texto]);

  if (readonly) {
    return <ReadonlyOutput id={id} meta={meta} value={value} {...(describedBy === undefined ? {} : { describedBy })} />;
  }

  return (
    <textarea
      id={id}
      ref={ref}
      rows={3}
      className={areaClass(invalid, 'resize-y leading-relaxed')}
      value={texto}
      required={required}
      aria-required={required || undefined}
      aria-invalid={invalid || undefined}
      aria-describedby={describedBy}
      maxLength={meta.max_length}
      onChange={(evento) => {
        const nuevo = evento.target.value;
        onChange(nuevo === '' && meta.null === true ? null : nuevo);
      }}
    />
  );
}
